export default __webpack_public_path__ + "static/acquisiton-color.url-030a7d6816b5e140c39dc34f68b3cafc.svg";